import { createTheme, ThemeOptions } from '@mui/material/styles';

export const plgThemeData: ThemeOptions = {
    palette: {
        primary: {
            main: '#eb0045',
            light: '#EEEDEE',
            dark: '#eb0045',
        },
        secondary: {
            main: '#eb0045',
            light: '#fff5f8',
        },
        background: {
            default: '#EEEDEE',
            paper: '#EEEDEE',
        },
        star: {
            empty: '#D1D5DB',
            filled: '#e6d130',
        },
        text: {
            primary: '#000000',
            secondary: '#eb0045',
            disabled: 'grey',
        },
        warning: {
            main: '#ffff00',
        },
        action: {
            disabled: '#9e9e9e',
        },
        border: {
            primary: '#eb0045',
        },
    },
    typography: {
        fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
        h1: {
            fontSize: '2.25rem',
            fontWeight: 700,
            marginBottom: '1.5rem',
            color: '#eb0045',
            textAlign: 'center',
        },
        h2: {
            fontSize: '1.875rem',
            fontWeight: 700,
            marginBottom: '1.5rem',
        },
        h3: {
            fontSize: '1.5rem',
            fontWeight: 700,
            marginBottom: '1rem',
            color: '#eb0045',
        },
        h4: {
            fontSize: '1rem',
            fontWeight: 'bold',
            color: '#000000',
            textAlign: 'left',
            marginTop: '1em',
            marginBottom: '1em',
        },
        h6: {
            fontSize: '0.8rem',
            fontWeight: 'bold',
            color: '#000000',
        },
        caption: {
            fontSize: '0.8rem',
            fontWeight: 'bold',
            color: '#eb0045',
            textAlign: 'left',
        },
        body1: {
            fontSize: '0.8rem',
            color: '#000000',
            arrowIconColor: '#FFFFFF', //for arrow in button
            priceQuoteBackground: '#f0f9ee',
            detailsTextColor: '#111928',
            checkBoxBackground: '#f3f4f6',
            descriptionTextColor: '#6b7280',
            ndrpSectionBackground: '#f9fafa',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    backgroundColor: '#eb0045',
                    borderRadius: '0.5rem',
                    '&:hover': {
                        backgroundColor: '#810026',
                    },
                    color: '#FFFFFF',
                },
            },
        },
        MuiList: {
            styleOverrides: {
                root: {
                    color: 'rgb(107 114 128)',
                    fill: '#43b02a',
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    fontSize: '1rem',
                    color: '#eb0045',
                    '&:hover': {
                        color: '#eb0045',
                    },
                    width: '1.5rem',
                    height: '1.5rem',
                    '&.Mui-disabled': {
                        color: '#9e9e9e',
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontWeight: 600,
                    color: 'rgb(17 24 39)',
                    fontSize: '1rem',
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    fontSize: '1rem',
                    fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
                },
            },
        },
    },
}

export const plgTheme = createTheme(plgThemeData);
